/* eslint-disable object-shorthand */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable vars-on-top */
/* eslint-disable strict */
/* eslint-disable no-var */
/* eslint-disable complexity */
(async function (algolia) {
  'use strict';

  // Read authenticatedUserToken from algolia_config (set by algolia_analytics.js.liquid)
  // Note: We read this fresh on each event to handle timing/race conditions on mobile
  var getAuthenticatedUserToken = function () {
    var _algoliaConfig = JSON.parse(localStorage.getItem('algolia_config') || '{}');
    var token = _algoliaConfig.authenticatedUserToken || window.algoliaShopify?.authenticatedUserToken || undefined;
    if (token) {
    }
    return token;
  };

  // Dedup guard: suppress identical viewedFilters / clickedFilters within 500ms
  // Catches duplicates from any source (snippets, PLP script, our own listeners)
  (function () {
    if (window.__algoliaAaWrapped) return; // only wrap once
    window.__algoliaAaWrapped = true;
    var _origAa = window.aa;
    if (typeof _origAa !== 'function') return;
    var _lastKey = null;
    var _lastTime = 0;
    window.aa = function (event) {
      var params = arguments[1] || {};
      var now = Date.now();

      // Suppress duplicate viewedFilters / clickedFilters within 500ms
      if (event === 'viewedFilters' || event === 'clickedFilters') {
        var key = event + ':' + JSON.stringify((params.filters || []).slice().sort());
        if (key === _lastKey && (now - _lastTime) < 500) return;
        _lastKey = key;
        _lastTime = now;
      }

      // Suppress generic convertedObjectIDs only when OUR search-modal wishlist handler just fired
      // if (event === 'convertedObjectIDs') {
      //   var wsFlag = window.__headerSearchWishlistFired;
      //   if (wsFlag) {
      //     var objKey = JSON.stringify((params.objectIDs || []).slice().sort());
      //     if (objKey === wsFlag.key && (now - wsFlag.time) < 2000) return;
      //   }
      // }

      return _origAa.apply(this, arguments);
    };
  })();

  var instantsearch = algolia.externals.instantsearch;
  var algoliasearch = algolia.externals.algoliasearch;
  var searchBox = algolia.externals.widgets.searchBox;
  var stats = algolia.externals.widgets.stats;
  var sortBy = algolia.externals.widgets.sortBy;
  var clearRefinements = algolia.externals.widgets.clearRefinements;
  var panel = algolia.externals.widgets.panel;
  var hits = algolia.externals.widgets.infiniteHits;
  var pagination = algolia.externals.widgets.pagination;
  var configure = algolia.externals.widgets.configure;
  var index_suffix = await algolia.config.index_suffix;
  var connectCurrentRefinements =
    algolia.externals.connectors.connectCurrentRefinements;


  var headerContainer = document.querySelector('#header-instant-search-container');
  if (!headerContainer) return;

  var collectionPageEnabled = false;

  /**
   * Array which will contain all filters to be applied while initiating the
   * search API call.
   */
  var searchFilters = [];


  var stockPolicyFilter = null;
  if (algolia.config.stock_policy) {
    if (algolia.config.stock_policy === 'allow') {
    } else if (algolia.config.stock_policy === 'deny') {
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      stockPolicyFilter = 'inventory_available:true';
    }
    if (stockPolicyFilter) {
      searchFilters.push(stockPolicyFilter);
    }
  }


  var results_selector = '#header-instant-search-container';

  var activeSortOrders = algolia.sortOrders;

  function getTrackedUiState(uiState) {
    var trackedUiState = {};
    Object.keys(uiState).forEach(function (k) {
      if (k === 'configure' || k === 'query' || k === 'search') {
        return;
      }
      trackedUiState[k] = uiState[k];
    });
    return trackedUiState;
  }

  var ALLOWED_FOREIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  var foreignRouteState;

  function singleIndex(indexName) {
    return {
      stateToRoute: function (uiState) {
        var route = getTrackedUiState(uiState[indexName] || {});
        route.search = uiState[indexName].query;
        return Object.assign({}, foreignRouteState, route);
      },
      routeToState: function (routeState) {
        if (!foreignRouteState) {
          foreignRouteState = ALLOWED_FOREIGN_PARAMS.reduce(function (acc, key) {
            acc[key] = routeState[key];
            return acc;
          }, {});
        }
        var state = {};
        state[indexName] = getTrackedUiState(routeState || {});
        state[indexName].query = routeState.search;
        return state;
      },
    };
  }

  var instant = {
    colors: algolia.config.colors,
    distinct: Boolean(algolia.config.show_products),
    facets: {
      hidden: algolia.hiddenFacets,
      shown: algolia.shownFacets,
      list: algolia.facets,
      widgets: algolia.facetsWidgets,
    },
    hitsPerPage: algolia.config.products_full_results_hits_per_page,
    search: instantsearch({
      searchClient: algoliasearch(
        algolia.config.app_id,
        algolia.config.search_api_key
      ),
      insights: true,
      indexName: algolia.config.index_prefix + 'products' + index_suffix,


      routing: false,
      searchFunction: function (searchFunctionHelper) {
        if (window.algoliaHeaderLoadingTimeout) clearTimeout(window.algoliaHeaderLoadingTimeout);
        var searchWrapper = document.querySelector('#header-instant-search-container');
        if (searchWrapper) {
          searchWrapper.classList.add('product-loading');
        }

        var page = searchFunctionHelper.getPage();

        // Debounce all searches at the gateway level.
        // Autocomplete bypasses queryHook and fires searchFunction on every
        // keystroke. This ensures only 1 API call goes out after 400ms of idle,
        // regardless of which code path triggered the search.
        if (instant.searchFunctionTimer) {
          clearTimeout(instant.searchFunctionTimer);
        }

        instant.searchFunctionTimer = setTimeout(function () {
          if (instant.distinct) {
            searchFunctionHelper.setQueryParameter('distinct', true);
          }

          if (searchFilters.length) {
            searchFunctionHelper.setQueryParameter(
              'filters',
              searchFilters.join(' AND ')
            );
          }

          var analyticsTags = (algolia && typeof algolia.getAnalyticsTags === 'function')
            ? algolia.getAnalyticsTags()
            : (window.algoliaShopify && typeof window.algoliaShopify.getAnalyticsTags === 'function')
              ? window.algoliaShopify.getAnalyticsTags()
              : [(document.documentElement.lang === 'ar' || window.location.pathname.startsWith('/ar/') ? 'language_ar' : 'language_en')];
          searchFunctionHelper.setQueryParameter('analyticsTags', analyticsTags);

          searchFunctionHelper.setPage(page);
          searchFunctionHelper.search();
        }, 400);

      },
    }),
    selector: results_selector,
    sortOrders: activeSortOrders
  };

  instant.search.client.addAlgoliaAgent('Shopify Integration');


  algolia.headerInstantSearch = instant;

  function readjust() {
    var width = instant.$results.offsetWidth;


    if (width === 0) {
      width = window.innerWidth;
    }

    var suffix = 'lg';
    if (width < 400) suffix = 'xs';
    else if (width < 800) suffix = 'sm';
    else if (width < 1200) suffix = 'md';

    instant.$results.classList.remove('ais-results-size-xs');
    instant.$results.classList.remove('ais-results-size-sm');
    instant.$results.classList.remove('ais-results-size-md');
    instant.$results.classList.remove('ais-results-size-lg');
    instant.$results.classList.add('ais-results-size-' + suffix);
  }

  //Link CSS and set up CSS variables
  // const cssFile = document.getElementById('template_algolia_instant_search.css');
  document.documentElement.style.setProperty(`--main-color`, `${algolia.config.colors.main}`);
  document.documentElement.style.setProperty(`--secondary-color`, `${algolia.config.colors.secondary}`);
  document.documentElement.style.setProperty(`--highlight-bg-color`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
  // algolia.appendStyle(cssFile.text);

  if (document.querySelectorAll(results_selector).length === 0) {
    return;
  }


  instant.$results = document.querySelector(instant.selector);
  instant.$results.innerHTML = '';



  var templateToUse = algolia.instantSearchHeaderTemplate;

  algolia.render(templateToUse, instant.$results, {
    facets: instant.facets.list,
    multipleSortOrders: activeSortOrders.length > 1,
  });

  readjust();

  window.addEventListener('resize', function () {
    readjust();
  });


  instant.search.addWidgets([
    {
      init: function () {

        const headerScope = document.querySelector('#header-instant-search-container');
        if (!headerScope) return;

        const filterButtons = headerScope.querySelectorAll('.ais-facets-button');
        var $closeButtons = headerScope.querySelectorAll('.icon__close, #show-results-button');
        var $facets = headerScope.querySelector('.ais-facets');

        var isArLocale = (algolia && typeof algolia.isArabic === 'function')
          ? algolia.isArabic()
          : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));

        var toggleFacets = function () {
          const isOpen = $facets.classList.contains('ais-facets__shown');
          $facets.classList.toggle('ais-facets__shown', !isOpen);
          filterButtons.forEach(button => {
            button.classList.toggle('is-open', !isOpen);
          });
        };

        filterButtons.forEach(button => {
          if (isArLocale) {
            button.childNodes.forEach(node => {
              if (node.nodeType === 3 && node.textContent.trim() === 'Filter') {
                node.textContent = node.textContent.replace('Filter', 'تصفية');
              }
            });
          }
          if (button.dataset.filterToggleBound) return;
          button.dataset.filterToggleBound = 'true';
          button.addEventListener('click', toggleFacets);
        });

        $closeButtons.forEach(btn => {
          if (btn.dataset.filterCloseBound) return;
          btn.dataset.filterCloseBound = 'true';
          btn.addEventListener('click', function () {
            if ($facets.classList.contains('ais-facets__shown')) {
              toggleFacets();
            }
          });
        });

        if (!headerScope.dataset.overlayCloseBound) {
          headerScope.dataset.overlayCloseBound = 'true';
          document.body.addEventListener('click', function (e) {
            const insideDrawer = e.composedPath().find(el => {
              return el && el.classList && (el.classList.contains('ais-facets') || el.classList.contains('ais-facets-button'));
            });
            if (insideDrawer) return;
            if ($facets && $facets.classList.contains('ais-facets__shown')) toggleFacets();
          });
        }
      },
    },
  ]);
  instant.search.addWidgets([
    configure({
      hitsPerPage: instant.hitsPerPage,
      facetingAfterDistinct: Boolean(algolia.config.show_products),
      enableRules: true,
      analyticsTags: (algolia && typeof algolia.getAnalyticsTags === 'function')
        ? algolia.getAnalyticsTags()
        : (window.algoliaShopify && typeof window.algoliaShopify.getAnalyticsTags === 'function')
          ? window.algoliaShopify.getAnalyticsTags()
          : [(document.documentElement.lang === 'ar' || window.location.pathname.startsWith('/ar/') ? 'language_ar' : 'language_en')],
    }),
  ]);


  instant.search.addWidgets([
    searchBox({
      container: '.ais-search-box-container',
      placeholder: algolia.translations.searchForProduct,
      showReset: false,
      showSubmit: false,
      queryHook: function (query, search) {
        if (instant.searchBoxTimer) {
          clearTimeout(instant.searchBoxTimer);
        }
        instant.searchBoxTimer = setTimeout(function () {
          search(query);
        }, 400);
      },
    }),
  ]);


  instant.search.addWidgets([
    {
      init: function (opts) {
        document
          .querySelector('.ais-clear-input-icon')
          .addEventListener('click', function () {
            opts.helper.setQuery('').search();
            var input = document.querySelector('.ais-search-box--input');
            input.value = '';
            input.focus();
          });
      },
      render: function (opts) {
        if (!opts.state.query) {
          document.querySelector('.ais-clear-input-icon').style.display =
            'none';
        } else {
          document.querySelector('.ais-clear-input-icon').style.display = '';
        }
      },
    },
  ]);


  instant.search.addWidgets([
    stats({
      container: '.ais-stats-container',
      templates: {
        text(data, { html }) {
          if (data.hasNoResults)
            return '';
          var isAr = (algolia && typeof algolia.isArabic === 'function')
            ? algolia.isArabic()
            : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
          const count = algolia.helpers.formatNumber(data.nbHits);
          const label = isAr ? 'منتج' : (data.nbHits === 1 ? 'product' : 'products');
          return html`${count} ${label}`;
        }
      }
    }),
    stats({
      container: '.ais-stats-container_mobile',
      templates: {
        text(data, { html }) {
          window.productSearchCount = data.nbHits;
          var isAr = (algolia && typeof algolia.isArabic === 'function')
            ? algolia.isArabic()
            : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
          const btns = document.querySelectorAll('#header-instant-search-container .show-results-button');
          btns.forEach(btn => {
            if (data.nbHits !== undefined) {
              btn.textContent = isAr ? `عرض ${data.nbHits} منتج` : `Show ${data.nbHits} Products`;
            }
          });
          if (data.hasNoResults)
            return '';
          const count = algolia.helpers.formatNumber(data.nbHits);
          const label = isAr ? 'منتج' : (data.nbHits === 1 ? 'product' : 'products');
          return html`(${count} ${label})`;
        }
      }
    }),
  ]);


  if (activeSortOrders.length > 1) {
    instant.search.addWidgets([
      sortBy({
        container: '.ais-sort-orders-container',
        items: instant.sortOrders,
        transformItems: function (items) {
          var isAr = (algolia && typeof algolia.isArabic === 'function')
            ? algolia.isArabic()
            : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
          if (isAr && algolia.AR_SORT_LABELS) {
            return items.map(function (item) {
              return Object.assign({}, item, {
                label: algolia.AR_SORT_LABELS[item.label] || item.label
              });
            });
          }
          return items;
        }
      }),
    ]);
  }


  var list = instant.facets.hidden.map(function (facet) {
    return facet.name;
  });
  instant.search.addWidgets([
    {
      getConfiguration: function () {
        return {
          facets: list,
          disjunctiveFacets: list,
        };
      },
      init: function () { },
    },
  ]);


  var createDataAttributes = function (refinement) {
    return Object.keys(refinement)
      .map(function (key) {
        return 'data-' + key + '="' + encodeURIComponent(refinement[key] || '') + '"';
      })
      .join(' ');
  };

  var renderListItem = function (item) {

    var facet = instant.facets.list.find(function (f) {
      return f.name === item.label;
    });
    return item.refinements
      .map(function (refinement) {
        return (
          '<li class="ais-current-refined-values--item">' +
          '  <a ' +
          createDataAttributes(refinement) +
          '    class="ais-current-refined-values--link">' +
          '    <div>' +
          '      <div class="ais-current-refined-values--label">' +
          '      </div> ' +
          refinement.label + '<svg class="icon icon__close" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.251 6.251a.857.857 0 0 1 1.212 0L12 10.788l4.537-4.537a.857.857 0 0 1 1.283 1.131l-.071.081L13.212 12l4.537 4.537.071.08a.857.857 0 0 1-1.283 1.132L12 13.212 7.463 17.75a.857.857 0 0 1-1.283-1.131l.071-.081L10.788 12 6.25 7.463l-.071-.08A.857.857 0 0 1 6.25 6.25Z" fill-rule="evenodd" clip-rule="evenodd"></path></svg>' +
          '    </div>' +
          '  </a>' +
          '</li>'
        );
      })
      .join('');
  };

  var renderCurrentRefinements = function (renderOptions) {
    var items = renderOptions.items;
    var refine = renderOptions.refine;
    var widgetParams = renderOptions.widgetParams;
    widgetParams.container.innerHTML =
      '<div class="ais-root ais-current-refined-values ais-facet">' +
      '  <ul class="ais-current-refined-values--list">' +
      items.map(renderListItem).join('') +
      '  </ul>' +
      '</div>';

    var drawerCurrentRefinementsRow = widgetParams.container.closest(
      '.filter-drawer__current-refinements'
    );
    if (drawerCurrentRefinementsRow) {
      drawerCurrentRefinementsRow.style.display = items.length > 0 ? '' : 'none';
    }

    Array.prototype.slice
      .call(
        widgetParams.container.querySelectorAll(
          '.ais-current-refined-values--link'
        )
      )
      .forEach(function (element) {
        element.addEventListener('click', function (event) {
          var item = Object.keys(event.currentTarget.dataset).reduce(function (
            acc,
            key
          ) {
            var itemData = {};
            itemData[key] = decodeURIComponent(event.currentTarget.dataset[key]);
            return algolia.assign({}, acc, itemData);
          },
            {});

          refine(item);
        });
      });
  };


  var customCurrentRefinements = connectCurrentRefinements(
    renderCurrentRefinements
  );

  var hasRefinements = function (helper, facetsList) {
    return facetsList.some(function (f) {
      return helper.state.isDisjunctiveFacetRefined(f.name) ||
        helper.state.isFacetRefined(f.name) ||
        Object.keys(helper.state.getNumericRefinements(f.name)).length > 0;
    });
  };

  var hasFacetValues = function (resultState, facetName) {
    return (
      resultState.facets.some(function (facet) { return facet.name === facetName; }) ||
      resultState.disjunctiveFacets.some(function (facet) { return facet.name === facetName; }) ||
      resultState.hierarchicalFacets.some(function (facet) { return facet.name === facetName; })
    );
  };

  var customCurrentRefinementsWithPanel = panel({
  })(customCurrentRefinements);

  var clearRefinementsWithPanel = panel({
  })(clearRefinements);

      instant.search.addWidgets([
      clearRefinementsWithPanel({
        container: document.querySelector('#header-instant-search-container .ais-clear-refinements-container'),
        templates: {
          resetLabel: algolia.translations.clearAll,
        },
      }),
      customCurrentRefinementsWithPanel({
        container: document.querySelector('#header-instant-search-container .ais-current-refined-values-container'),
      }),
    ]);

    var drawerCurrentRefinementsContainer = document.querySelector(
      '#header-instant-search-container .filter-drawer__current-refinements-container'
    );
    if (drawerCurrentRefinementsContainer) {
      instant.search.addWidgets([
        customCurrentRefinementsWithPanel({
          container: drawerCurrentRefinementsContainer,
        }),
      ]);
    }
    
  

  instant.facets.widgets.forEach(function (widget) {

    var originalContainer = widget.params.container;
    var scopedContainer = '#header-instant-search-container ' + originalContainer;

    var widgetParams = Object.assign({}, widget.params, {
      container: scopedContainer
    });

    var facetWithPanel = panel({
      hidden: function (options) {
        var hide = !hasFacetValues(options.results, widget.params.attribute);
        var displayStyle = hide ? 'none' : '';
        var parentContainerClassName = '#header-instant-search-container .ais-facet-' + encodeURIComponent(
          widget.params.attribute
        ).replace(/\./g, '\\.').replace(/\%/g, '\\%');
        var parentContainer = document.querySelector(parentContainerClassName);

        if (parentContainer) {
          parentContainer.style.display = displayStyle;
        }

        return hide;
      },
    })(widget.widget);

    instant.search.addWidgets([facetWithPanel(widgetParams)]);
  });


  instant.search.addWidgets([
    hits({
      container: '#header-instant-search-container .ais-hits-container',
      showPrevious: true,
      templates: {
        item(hit, { html, components }) {
          return algolia.instantSearchProductTemplate(hit, html, components);
        },
        empty(results, { html }) {
          return algolia.instantSearchNoResultTemplate(html);
        },
        showPreviousText(data, { html }) {
          return html`<span>${algolia.translations.loadprevious}</span>`;
        },
        showMoreText(data, { html }) {
          const helper = instant.search.helper;
          const results = helper.lastResults;

          if (!results) return html`<span>${algolia.translations.loadmore}</span>`;
          const totalHits = results.nbHits;
          const hitsPerPage = helper.state.hitsPerPage;
          const currentPage = helper.state.page || 0;
          const loadedHits = (currentPage + 1) * hitsPerPage;
          const remainingHits = Math.max(0, totalHits - loadedHits);
          const nextLoadCount = Math.min(hitsPerPage, remainingHits);
          var isAr = (algolia && typeof algolia.isArabic === 'function')
            ? algolia.isArabic()
            : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
          return html`
            <span class="load-more-text">
              ${isAr ? 'تحميل المزيد' : 'Load Next'} 
              ${remainingHits > 0 ? ` ${nextLoadCount}` : ''}
            </span>
          `;
        },
        searchableLoadingIndicator(data, { html }) {
          var isAr = (algolia && typeof algolia.isArabic === 'function')
            ? algolia.isArabic()
            : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));
          return html`<span>${isAr ? 'جاري التحميل...' : 'loading'}</span>`;
        }
      },
      transformItems: function (items) {
        return items.map(item => ({
          ...item,
          _distinct: instant.distinct,
          can_order: true,
          queryID: item.__queryID,
          productPosition: item.__position,
          index: instant.search.mainIndex.getIndexName()
        }));
      }
    })
  ]);

  function resetHeaderFilters() {
    if (!instant.search.helper) return;

    instant.facets.list.forEach(function (facet) {
      instant.search.helper.clearRefinements(facet.name);
    });

    instant.search.helper.setPage(0);
  }
  // The header Liquid snippet also resets filters when its modal closes.
  // Expose the helper explicitly because this asset may be wrapped in a scope.
  window.resetHeaderFilters = resetHeaderFilters;

  let previousQuery = '';
  document.addEventListener('input', (e) => {
    if (e.target.matches('.aa-Input')) {
      if (instant.search.helper) {
        if (window.algoliaHeaderLoadingTimeout) clearTimeout(window.algoliaHeaderLoadingTimeout);
        var searchWrapper = document.querySelector('#header-instant-search-container');
        if (searchWrapper) {
          searchWrapper.classList.add('product-loading');
        }

        const newQuery = e.target.value;

        // NOTE: Do NOT call helper.setQuery().search() here.
        // The Autocomplete widget fires searches directly into InstantSearch
        // synchronously on each keypress. Calling .search() here would cause
        // a second duplicate query to fire ~800ms after autocomplete already did.
        // We only need to clear filters/page as a side-effect.
        resetHeaderFilters();
        if (previousQuery && newQuery && !newQuery.startsWith(previousQuery) && !previousQuery.startsWith(newQuery)) {
          instant.facets.list.forEach(function (facet) {
            instant.search.helper.clearRefinements(facet.name);
          });
        }
        previousQuery = newQuery;
      }
    }
  });


  document.addEventListener('click', (e) => {
    if (e.target.closest('.aa-ClearButton')) {
      if (instant.search.helper) {
        instant.search.helper.setQuery('').search();
      }
    }
  });
  var headerViewedQueryID = null;
  var headerViewedObjectIDs = [];
  var headerViewedIndex = null;
  instant.search.start();
  document.addEventListener('click', function (e) {

    const confirmBtn = e.target.closest('#header-instant-search-container .show-results-button');
    if (!confirmBtn) return;

    requestAnimationFrame(() => {

      const helper = window.algoliaShopify.headerInstantSearch.search.helper;
      if (!helper) return;

      const state = helper.state;

      let count = 0;

      Object.values(state.disjunctiveFacetsRefinements || {}).forEach(v => {
        count += v.length;
      });

      Object.values(state.facetsRefinements || {}).forEach(v => {
        count += v.length;
      });

      Object.values(state.numericRefinements || {}).forEach(operators => {
        Object.values(operators).forEach(values => {
          if (values.length) count += 1;
        });
      });

      const counters = document.querySelectorAll('#header-instant-search-container .filter-count');

      counters.forEach(el => {
        el.textContent = count > 0 ? count : '';
        el.style.display = count ? 'inline-block' : 'none';
      });

    });

  });
  document.addEventListener('click', function (e) {

    const closeBtn = e.target.closest('#header-instant-search-container .mobile-filter-header .overlay__close.icon-button');
    if (!closeBtn) return;

    requestAnimationFrame(() => {

      const helper = window.algoliaShopify.headerInstantSearch.search.helper;
      if (!helper) return;

      const state = helper.state;

      let count = 0;

      Object.values(state.disjunctiveFacetsRefinements || {}).forEach(v => {
        count += v.length;
      });

      Object.values(state.facetsRefinements || {}).forEach(v => {
        count += v.length;
      });

      Object.values(state.numericRefinements || {}).forEach(operators => {
        Object.values(operators).forEach(values => {
          if (values.length) count += 1;
        });
      });

      const counters = document.querySelectorAll('#header-instant-search-container .filter-count');

      counters.forEach(el => {
        el.textContent = count > 0 ? count : '';
        el.style.display = count ? 'inline-block' : 'none';
      });

    });

  });

  instant.search.on('render', function () {
    window.algoliaHeaderLoadingTimeout = setTimeout(function() {
      var searchWrapper = document.querySelector('#header-instant-search-container');
      if (searchWrapper) {
        searchWrapper.classList.remove('product-loading');
      }
    }, 400);

    var results = instant.search.helper.lastResults;
    const headerScope = instant.$results;

    // ===== ALGOLIA RULE REDIRECT =====
    // Algolia Rule consequence stores redirect in results.renderingContent.redirect.url
    if (isSubmitTriggered && results && results.renderingContent && results.renderingContent.redirect && results.renderingContent.redirect.url) {
      isSubmitTriggered = false;
      var redirectUrl = results.renderingContent.redirect.url;
      // Hide UI immediately to avoid flash
      var _c = document.getElementById('header-instant-search-container');
      if (_c) _c.style.display = 'none';
      window.location.href = redirectUrl;
      return; // stop further rendering
    }

    // No redirect — if isSubmitTriggered was set, reset it and show the container now
    if (isSubmitTriggered) {
      isSubmitTriggered = false;
      var _container = document.getElementById('header-instant-search-container');
      var _qsw = document.querySelector('.quick-search-wrapper');
      if (_container) _container.style.display = 'block';
      if (_qsw) _qsw.classList.add('hidden-for-instant-search');
    }

    // ===== EXISTING CODE CONTINUES =====
    if (results && results.hits && results.hits.length) {
      headerViewedQueryID = results.queryID;
      headerViewedIndex = results.index;
      headerViewedObjectIDs = results.hits.map(function (hit) {
        return hit.objectID;
      }).slice(0, 20);
    }
    if (typeof track_addtocart_buttons === 'function') {
      track_addtocart_buttons();
    }
    // --- Load-more button text update ---
    if (headerScope && results) {
      const helper = instant.search.helper;
      const loadMoreBtn = headerScope.querySelector('.ais-InfiniteHits-loadMore');
      var isAr = (algolia && typeof algolia.isArabic === 'function')
        ? algolia.isArabic()
        : Boolean((window.algoliaShopify && (window.algoliaShopify.isArabicMode === true || (typeof window.algoliaShopify.isArabic === 'boolean' && window.algoliaShopify.isArabic))) || document.documentElement.lang === 'ar' || (window.Shopify && window.Shopify.locale === 'ar') || window.location.pathname.startsWith('/ar/'));

      if (loadMoreBtn) {
        const totalHits = results.nbHits;
        const hitsPerPage = helper.state.hitsPerPage;
        const currentPage = helper.state.page || 0;
        const loadedHits = (currentPage + 1) * hitsPerPage;
        const remainingHits = Math.max(0, totalHits - loadedHits);
        const nextLoadCount = Math.min(hitsPerPage, remainingHits);
        const textSpan = loadMoreBtn.querySelector('.load-more-text');
        if (textSpan) {
          textSpan.textContent = isAr
            ? `تحميل المزيد ${remainingHits > 0 ? nextLoadCount : ''}`.trim()
            : `Load next ${remainingHits > 0 ? nextLoadCount : ''}`.trim();
        }
      }

      // --- Progress bar injection ---
      const hitsContainer = headerScope.querySelector('.ais-InfiniteHits-list');
      if (hitsContainer) {
        let progressContainer = headerScope.querySelector('.custom-load-more-container');
        if (!progressContainer) {
          progressContainer = document.createElement('div');
          progressContainer.className = 'custom-load-more-container';
          progressContainer.innerHTML = `
          <div class="progress-text"></div>
          <div class="progress-bar"><div class="progress-fill"></div></div>
        `;
          hitsContainer.parentNode.insertBefore(progressContainer, hitsContainer.nextSibling);
        }

        const totalHits = results.nbHits;
        const hitsPerPage = helper.state.hitsPerPage;
        const currentPage = helper.state.page || 0;
        const loadedHits = (currentPage + 1) * hitsPerPage;
        const remainingHits = Math.max(0, totalHits - loadedHits);
        const viewedHits = Math.max(0, totalHits - remainingHits);
        const percentViewed = Math.min((viewedHits / totalHits) * 100, 100);

        const progressText = progressContainer.querySelector('.progress-text');
        const progressFill = progressContainer.querySelector('.progress-fill');
        if (progressText && progressFill) {
          progressText.textContent = isAr
            ? `لقد شاهدت ${viewedHits} من أصل ${totalHits} منتج`
            : `You've viewed ${viewedHits} of ${totalHits} products`;
          progressFill.style.width = `${percentViewed}%`;
        }
      }
    }


    // ===============================
    // ALGOLIA RULE BANNER (ROBUST FIX)
    // ===============================
    if (!headerScope) return;

    // Always remove ALL banners first (from entire header container)
    document.querySelectorAll('#header-instant-search-container .algolia-rule-banner')
      .forEach(function (el) {
        el.remove();
      });

    // Only inject if current results actually have banner
    if (
      results &&
      results.userData &&
      results.userData.length &&
      results.userData[0].banners &&
      results.userData[0].banners.length
    ) {

      var bannerData = results.userData[0].banners[0];

      // Important: ensure query is not empty
      if (results.query && results.query.trim() !== '') {

        var bannerNode = document.createElement('div');
        bannerNode.className = 'search-banner algolia-rule-banner';

        var srcsetAttr = "";
        if (bannerData.image && bannerData.image.indexOf('cdn.shopify.com') !== -1) {
          var srcsetList = [360, 540, 720, 900, 1080, 1296, 1512, 1728, 1950].map(function(w) {
            var base = bannerData.image.split('?')[0];
            var query = bannerData.image.split('?')[1] ? '?' + bannerData.image.split('?')[1] : '';
            var withoutSize = base.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master|original|\d+x\d*)(\.\w{2,4})$/i, '$2');
            var newUrl = withoutSize.replace(/(\.[^.]+)$/, '_' + w + 'x$1');
            return newUrl + query + ' ' + w + 'w';
          });
          srcsetAttr = 'srcset="' + srcsetList.join(', ') + '" sizes="100vw"';
        }

        bannerNode.innerHTML = `
      <a class="image-url" href="${bannerData.link}">
        <img src="${bannerData.image}" ${srcsetAttr} alt="Search Banner" width="1920" loading="lazy">
      </a>
    `;

        var aisBlock = headerScope.querySelector('.ais-block');
        if (aisBlock) {
          aisBlock.prepend(bannerNode);
        }
      }
    }
  });
  var headerLastViewedQueryIDSent = null;
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;

    var input = e.target.closest('.aa-Input');
    if (!input) return;

    if (
      headerViewedQueryID &&
      headerViewedObjectIDs.length &&
      typeof aa === 'function' &&
      headerViewedQueryID !== headerLastViewedQueryIDSent
    ) {
      const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';
      const authenticatedUserToken = getAuthenticatedUserToken();
      aa('viewedObjectIDs', {
        eventName: 'viewedObjectIDs',
        index: headerViewedIndex,
        objectIDs: headerViewedObjectIDs.slice(0, 20),
        queryID: headerViewedQueryID,
        userToken: userToken,
        authenticatedUserToken: authenticatedUserToken
      });
      headerLastViewedQueryIDSent = headerViewedQueryID;
    }

  });


  document.addEventListener('blur', function (e) {
    var input = e.target.closest('.aa-Input');
    if (!input) return;

    setTimeout(function () {

      if (
        headerViewedQueryID &&
        headerViewedObjectIDs.length &&
        typeof aa === 'function' &&
        headerViewedQueryID !== headerLastViewedQueryIDSent
      ) {

        const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';
        const authenticatedUserToken = getAuthenticatedUserToken();
        aa('viewedObjectIDs', {
          eventName: 'viewedObjectIDs',
          index: headerViewedIndex,
          objectIDs: headerViewedObjectIDs,
          queryID: headerViewedQueryID,
          userToken: userToken,
          authenticatedUserToken: authenticatedUserToken
        });

        headerLastViewedQueryIDSent = headerViewedQueryID;

      }

    }, 600);

  }, true);

  document.addEventListener('search', function (e) {
    var input = e.target.closest('.aa-Input');
    if (!input) return;

    if (
      headerViewedQueryID &&
      headerViewedObjectIDs.length &&
      typeof aa === 'function' &&
      headerViewedQueryID !== headerLastViewedQueryIDSent
    ) {

      const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';
      const authenticatedUserToken = getAuthenticatedUserToken();
      aa('viewedObjectIDs', {
        eventName: 'viewedObjectIDs',
        index: headerViewedIndex,
        objectIDs: headerViewedObjectIDs.slice(0, 20),
        queryID: headerViewedQueryID,
        userToken: userToken,
        authenticatedUserToken: authenticatedUserToken
      });

      headerLastViewedQueryIDSent = headerViewedQueryID;
    }
  });





  (function () {
    const headerSelector = '#header-instant-search-container';
    const updateHeaderSortLabel = () => {
      const container = document.querySelector(headerSelector);
      if (!container) return;
      const select = container.querySelector('.ais-sort-orders-container select');
      const label = container.querySelector('.current-sort-label');
      if (select && label && select.selectedIndex >= 0) {
        label.textContent = select.options[select.selectedIndex].text;
      }
    };


    function initDesktopSortDropdown() {
      const container = document.querySelector(headerSelector);
      if (!container) return;
      
      const desktopSortContainer = container.querySelector('.desktop-sort-container');
      const desktopSortTrigger = container.querySelector('.desktop-sort-trigger');
      const desktopSortPanel = container.querySelector('.desktop-sort-panel');
      const desktopSortLabel = container.querySelector('.desktop-sort-label');
      const algoliaSelect = container.querySelector('.ais-sort-orders-container select');

      if (!desktopSortContainer || !desktopSortTrigger || !desktopSortPanel || !algoliaSelect) return;
      if (desktopSortContainer.dataset.listenerAttached) return;
      desktopSortContainer.dataset.listenerAttached = 'true';

      const closeDropdown = () => {
        desktopSortContainer.classList.remove('open');
        desktopSortTrigger.setAttribute('aria-expanded', 'false');
      };

      const openDropdown = () => {
        buildOptions();
        desktopSortContainer.classList.add('open');
        desktopSortTrigger.setAttribute('aria-expanded', 'true');
      };

      const buildOptions = () => {
        desktopSortPanel.innerHTML = '';
        const options = Array.from(algoliaSelect.options);
        
        options.forEach((opt, index) => {
          const btn = document.createElement('button');
          btn.className = 'desktop-sort-option';
          btn.setAttribute('role', 'option');
          btn.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
          btn.dataset.value = opt.value;
          
          if (opt.selected) {
            btn.classList.add('active');
            desktopSortLabel.textContent = opt.text;
          }

          const textSpan = document.createElement('span');
          textSpan.textContent = opt.text;
          btn.appendChild(textSpan);

          if (opt.selected) {
            const checkIcon = document.createElement('span');
            checkIcon.className = 'icon icon_check';
            checkIcon.innerHTML = `<svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 5L5 9L13 1" stroke="black" stroke-width="2"/>
            </svg>`;
            btn.appendChild(checkIcon);
          }

          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            algoliaSelect.value = opt.value;
            desktopSortLabel.textContent = opt.text;
            
            window.algoliaShopify = window.algoliaShopify || {};
            window.algoliaShopify.dynamicIndexName = opt.value;
            console.log('Algolia Header Sort Changed -> Index updated to:', opt.value);

            algoliaSelect.dispatchEvent(new Event('change', { bubbles: true }));
            closeDropdown();
          });

          desktopSortPanel.appendChild(btn);
        });
      };

      desktopSortTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (desktopSortContainer.classList.contains('open')) {
          closeDropdown();
        } else {
          openDropdown();
        }
      });

      document.addEventListener('click', (e) => {
        if (desktopSortContainer.classList.contains('open') && !desktopSortContainer.contains(e.target)) {
          closeDropdown();
        }
      });

      buildOptions();
    }

    let sentViewedObjectIDs = new Set();
    let processingViews = false;
    let lastHeaderSignature = '';

    instant.search.on('render', function() {
      updateHeaderSortLabel();
      initDesktopSortDropdown();
      if (typeof window.reloadThirdPartyWishlistApp === 'function') {
        window.reloadThirdPartyWishlistApp();
      }

      if (processingViews) return;

      // Do not process views if the results object hasn't actually changed 
      // (ignores intermediate loading states when a filter is clicked)
      if (instant.search.helper?.lastResults) {
        if (instant.search.helper.lastResults === window._lastAlgoliaHeaderResults) {
          return;
        }
        window._lastAlgoliaHeaderResults = instant.search.helper.lastResults;
      }

      processingViews = true;

      const state = instant.search.helper?.lastResults?._state || instant.search.helper?.state;
      if (state) {
        const currentSignature = JSON.stringify({
          q: state.query,
          f: state.facetsRefinements,
          n: state.numericRefinements,
          d: state.disjunctiveFacetsRefinements
        });
        if (currentSignature !== lastHeaderSignature) {
          sentViewedObjectIDs.clear();
          lastHeaderSignature = currentSignature;
        }
      }

      // Prevent firing on every page load by ensuring there is an active search query
      if (!state || !state.query || state.query.trim() === '') {
        processingViews = false;
        return;
      }

      const currentHits = instant.search.helper?.lastResults?.hits || [];
      const newObjectIDs = currentHits
        .map(hit => hit.objectID)
        .filter(id => !sentViewedObjectIDs.has(id));

      if (newObjectIDs.length > 0) {
        newObjectIDs.forEach(id => sentViewedObjectIDs.add(id));

        const user_Token = localStorage.getItem('_ALGOLIA_USER_TOKEN');
        const _algoliaConfig = JSON.parse(localStorage.getItem('algolia_config') || '{}');
        const authenticatedUserToken = _algoliaConfig.authenticatedUserToken || window.algoliaShopify?.authenticatedUserToken || undefined;
        const activeIndex = instant.search.helper?.lastResults?.index || (algolia.config.index_prefix + 'products');
        
        if (typeof aa === 'function') {
          setTimeout(() => {
            
            for (let i = 0; i < newObjectIDs.length; i += 20) {
              const chunk = newObjectIDs.slice(i, i + 20);
              aa('viewedObjectIDs', {
                eventName: 'viewedObjectIDs',
                index: activeIndex,
                objectIDs: chunk,
                userToken: user_Token,
                authenticatedUserToken: authenticatedUserToken
              });
            }
          }, 800);
        }
      }
      processingViews = false;
    });


    document.addEventListener('click', (e) => {

      const headerContainer = document.querySelector(headerSelector);
      if (!headerContainer || !headerContainer.contains(e.target)) {

        if (!e.target.classList.contains('mobile-sort-overlay')) return;

        if (!e.target.closest(headerSelector)) return;
      }


      const sortBtn = e.target.closest('.bottom-sort-button, .mobile-sort-button');
      if (sortBtn && headerContainer.contains(sortBtn)) {
        e.preventDefault();
        const popup = headerContainer.querySelector('.mobile-sort-popup');
        const select = headerContainer.querySelector('.ais-sort-orders-container select');
        const optionsContainer = headerContainer.querySelector('.mobile-sort-options');

        if (popup && select && optionsContainer) {
          optionsContainer.innerHTML = '';
          Array.from(select.options).forEach(opt => {
            const btn = document.createElement('button');
            btn.className = 'mobile-sort-option';
            if (opt.selected) btn.classList.add('active');
            btn.textContent = opt.text;
            btn.dataset.value = opt.value;
            optionsContainer.appendChild(btn);
          });
          popup.classList.add('show');
          document.body.style.overflow = 'hidden';
        }
        return;
      }


      if (e.target.closest('.mobile-sort-close') || e.target.classList.contains('mobile-sort-overlay')) {
        const popup = headerContainer.querySelector('.mobile-sort-popup');
        if (popup && popup.classList.contains('show')) {
          popup.classList.remove('show');
          document.body.style.overflow = '';
        }
        return;
      }


      const optionBtn = e.target.closest('.mobile-sort-option');
      if (optionBtn && headerContainer.contains(optionBtn)) {
        const select = headerContainer.querySelector('.ais-sort-orders-container select');
        const popup = headerContainer.querySelector('.mobile-sort-popup');
        if (select) {
          select.value = optionBtn.dataset.value;
          
          window.algoliaShopify = window.algoliaShopify || {};
          window.algoliaShopify.dynamicIndexName = optionBtn.dataset.value;
          console.log('Algolia Header Mobile Sort Changed -> Index updated to:', optionBtn.dataset.value);
          
          select.dispatchEvent(new Event('change', { bubbles: true }));
          if (popup) {
            popup.classList.remove('show');
            document.body.style.overflow = '';
          }
        }
      }
    });


    document.addEventListener('change', (e) => {
      if (e.target.matches(`${headerSelector} .ais-sort-orders-container select`)) {
        updateHeaderSortLabel();
      }
    });

    // clickedFilters — use 'change' event on checkbox to fire exactly once per toggle
    document.addEventListener('change', function (e) {
      if (!e.target.closest('#header-instant-search-container')) return;

      const checkbox = e.target.matches('.ais-RefinementList-checkbox, .ais-Menu-radio') ? e.target : null;
      if (!checkbox) return;

      // Only fire when filter is being APPLIED (checked), not removed
      if (!checkbox.checked) return;

      const facetValue = checkbox.getAttribute('data-value') || checkbox.value;
      if (!facetValue) return;

      // Walk up to the dropdown wrapper to get the facet attribute name
      const facetContainer = checkbox.closest('.ais-facet-dropdown-wrapper');
      let facetKey = 'unknown_facet';
      if (facetContainer) {
        const cls = Array.from(facetContainer.classList).find(c =>
          c.startsWith('ais-facet-') &&
          c !== 'ais-facet-dropdown-wrapper' &&
          c !== 'ais-facet-disjunctive' &&
          c !== 'ais-facet-slider' &&
          !c.includes('--')
        );
        if (cls) {
          facetKey = cls.replace('ais-facet-', '');
          facetKey = decodeURIComponent(facetKey.replace(/\\%/g, '%').replace(/\\\./g, '.'));
        }
      }

      // Removed redundant aa('clickedFilters') call here.
      // This is now fully managed by the global robust listener in global.js
      // which properly extracts panel group names and active items for both Header and PLP.
    });

  })();



  document.addEventListener('click', function (e) {

    const productLink = e.target.closest('#header-instant-search-container .algolia-product-link');
    if (!productLink || !productLink.dataset.algoliaQueryid) return;

    const objectID = productLink.dataset.algoliaObjectid;
    const now = Date.now();
    window.lastAlgoliaClick = window.lastAlgoliaClick || { time: 0, id: null };
    
    if (window.lastAlgoliaClick.id === objectID && now - window.lastAlgoliaClick.time < 500) {
      return; // Skip duplicate click within 500ms
    }
    window.lastAlgoliaClick = { time: now, id: objectID };

    sessionStorage.setItem('algolia_queryID', productLink.dataset.algoliaQueryid);
    sessionStorage.setItem('algolia_objectID', objectID);
    sessionStorage.setItem('algolia_index', productLink.dataset.algoliaIndex);

    const authenticatedUserToken = getAuthenticatedUserToken();
    const userToken = localStorage.getItem('_ALGOLIA_USER_TOKEN') || 'anonymous';

    aa('clickedObjectIDsAfterSearch', {
      eventName: 'clickedObjectIDsAfterSearch',
      index: productLink.dataset.algoliaIndex,
      objectIDs: [objectID],
      positions: [parseInt(productLink.dataset.algoliaPosition, 10)],
      queryID: productLink.dataset.algoliaQueryid,
      userToken: userToken,
      authenticatedUserToken: authenticatedUserToken
    });

  });

  // Wishlist in header instant search — sets sessionStorage so exponea_wishlist.liquid
  // fires convertedObjectIDsAfterSearch via isFromInstantSearch (no direct aa() here)
  document.addEventListener('click', function (e) {
    const action = e.target.closest('#header-instant-search-container wishlist-button-collection');
    if (!action) return;

    const product = action.closest('.ais-InfiniteHits-item')?.querySelector('.ais-product');
    if (!product) return;

    const queryID = product.dataset.algoliaQueryid;
    const objectID = product.dataset.algoliaObjectid;
    const index = product.dataset.algoliaIndex;
    const position = parseInt(product.dataset.algoliaPosition, 10);

    if (!queryID || !objectID || !position) return;

    sessionStorage.setItem('algolia_queryID', queryID);
    sessionStorage.setItem('algolia_objectID', objectID);
    sessionStorage.setItem('algolia_index', index);

  });

})(window.algoliaShopify);
